import React, { useState } from 'react';

const STAGES = [
  { id: 'warmup',  label: 'WARMUP',   short: '01',
    court1: { solo: 'ALL TEAMS' },
    court2: { solo: 'ALL TEAMS' },
    note: 'All 4 teams hit both courts. Serve receive, hitting lines, light scrimmage. 45 minutes.' },
  { id: 'r1',      label: 'ROUND 1',  short: '02',
    court1: { left: 'A',    right: 'B'    },
    court2: { left: 'C',    right: 'D'    },
    note: '20-minute hard clock. First to 25, cap 27. Two games at once - no team sits out.' },
  { id: 'r2',      label: 'ROUND 2',  short: '03',
    court1: { left: 'A',    right: 'C'    },
    court2: { left: 'B',    right: 'D'    },
    note: 'Same format. Every team plays every other team once.' },
  { id: 'r3',      label: 'ROUND 3',  short: '04',
    court1: { left: 'A',    right: 'D'    },
    court2: { left: 'B',    right: 'C'    },
    note: 'Final round robin game. All 6 possible matchups covered after this.' },
  { id: 'seed',    label: 'SEEDING',  short: '05',
    court1: { left: '-',    right: '-'    },
    court2: { left: '-',    right: '-'    },
    note: '15-minute break. Standings posted: 2 pts per win. Tiebreakers: head-to-head, point diff, points scored.' },
  { id: 'finals',  label: 'FINALS',   short: '06',
    court1: { left: '3rd',  right: '4th',  tag: 'BRONZE' },
    court2: { left: '1st',  right: '2nd',  tag: 'GOLD'   },
    note: 'Best of 3 sets · 25/25/15 · win by 2 capped at 30. Bronze and Gold run side-by-side.' },
];

const RED = '#9D1515';
const GOLD = '#FFD700';
const BRONZE = '#cd7f32';

export default function BlitzInfoModal({ open, onClose }) {
  const [stageIdx, setStageIdx] = useState(0);
  if (!open) return null;
  const stage = STAGES[stageIdx];

  const wrap = {
    position: 'fixed', inset: 0, zIndex: 100,
    background: 'rgba(0,0,0,0.92)', // no backdrop blur: recompositing it on every scroll frame lags (see OvrCupInfoModal)
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
    padding: 24, overflowY: 'auto',
  };
  const modal = {
    background: '#0a0a0a', border: `2px solid ${RED}`,
    maxWidth: 860, width: '100%',
    color: '#fff', fontFamily: "'Inter', system-ui, sans-serif",
    marginTop: 20, marginBottom: 60,
  };
  const hero = {
    background: `linear-gradient(135deg, ${RED} 0%, #6a0e0e 100%)`,
    padding: '40px 32px 32px', position: 'relative',
  };
  const closeBtn = {
    position: 'absolute', top: 14, right: 14,
    background: 'rgba(0,0,0,0.4)', color: '#fff',
    border: '1px solid rgba(255,255,255,0.3)',
    width: 36, height: 36, cursor: 'pointer', fontSize: 18, fontWeight: 700,
  };
  const sectionWrap = { padding: '28px 32px' };
  const sectionTitle = {
    fontFamily: "'Bebas Neue','Oswald',sans-serif",
    fontSize: 24, letterSpacing: '0.1em', color: '#fff',
    margin: '0 0 14px', borderBottom: `1px solid ${RED}`, paddingBottom: 8,
  };
  const tableWrap = { overflowX: 'auto', marginTop: 8 };
  const tbl = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
  const td = { padding: '10px 12px', borderBottom: '1px solid #1f1f1f', color: 'rgba(255,255,255,0.9)' };
  const tdLabel = { ...td, fontWeight: 600, color: '#fff', width: 160 };

  return (
    <div style={wrap} onClick={onClose}>
      <style>{`
        @media (max-width: 640px) {
          .blitz-hero { padding: 28px 18px 22px !important; }
          .blitz-hero h1 { font-size: 46px !important; }
          .blitz-section { padding: 18px 16px !important; }
          .blitz-section h2 { font-size: 20px !important; }
          .blitz-close-cta { padding: 16px 16px 28px !important; }
          .blitz-close-cta button { padding: 12px 24px !important; font-size: 14px !important; }
          .blitz-table { font-size: 12px !important; }
          .blitz-table td { padding: 8px 10px !important; }
          .blitz-tabs { padding: 0 !important; }
          .blitz-tab-btn { flex: 1 1 calc(50% - 6px) !important; font-size: 11px !important; padding: 8px 10px !important; }
          .blitz-court-name { font-size: 36px !important; }
          .blitz-court-vs { font-size: 14px !important; }
        }
      `}</style>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <div style={hero} className="blitz-hero">
          <button onClick={onClose} style={closeBtn} aria-label="Close">✕</button>
          <div style={{ fontSize: 11, letterSpacing: '0.24em', color: 'rgba(255,255,255,0.8)', fontWeight: 700, marginBottom: 14 }}>
            OVR · MINI TOURNAMENT
          </div>
          <h1 style={{
            fontFamily: "'Bebas Neue','Oswald',sans-serif",
            fontSize: 'clamp(48px, 8vw, 84px)',
            letterSpacing: '0.04em', lineHeight: 0.95,
            margin: 0, textShadow: '0 4px 16px rgba(0,0,0,0.4)',
          }}>
            OVR <em style={{ fontStyle: 'italic' }}>BLITZ</em>
          </h1>
          <div style={{ fontSize: 14, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.85)', marginTop: 14, fontWeight: 600 }}>
            Fast. Loud. Decisive. · 4 Hours · 4 Teams · 2 Courts
          </div>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <p style={{ fontSize: 15, lineHeight: 1.6, color: 'rgba(255,255,255,0.78)', margin: 0 }}>
            Blitz is OVR's new mini-tournament format. Built for players who want competitive
            volleyball without giving up a full Saturday. <strong style={{ color: '#fff' }}>Guaranteed games,
            no team sits out, and the medal rounds run side-by-side.</strong>
          </p>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <h2 style={sectionTitle}>AT A GLANCE</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12 }}>
            {[
              ['Format', '4 Teams'],
              ['Courts', '2 Live'],
              ['Block', '4 Hours'],
              ['Team of 6', '$150'],
            ].map(([k, v]) => (
              <div key={k} style={{ background: '#131313', border: '1px solid #2a2a2a', borderLeft: `3px solid ${RED}`, padding: '14px 16px' }}>
                <div style={{ fontSize: 10, letterSpacing: '0.18em', color: '#888', textTransform: 'uppercase', marginBottom: 4 }}>{k}</div>
                <div style={{ fontFamily: "'Bebas Neue','Oswald',sans-serif", fontSize: 24, letterSpacing: '0.04em', color: '#fff' }}>{v}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <h2 style={sectionTitle}>HOW THE DAY RUNS</h2>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', margin: '0 0 18px' }}>
            Tap a stage below to see who's on each court at that moment.
          </p>

          <div className="blitz-tabs" style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 18 }}>
            {STAGES.map((s, i) => {
              const active = i === stageIdx;
              const done   = i < stageIdx;
              return (
                <button
                  key={s.id}
                  className="blitz-tab-btn"
                  onClick={() => setStageIdx(i)}
                  style={{
                    flex: '1 1 110px',
                    background: active ? RED : 'transparent',
                    color: active ? '#fff' : (done ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.4)'),
                    border: `1px solid ${active ? RED : (done ? 'rgba(157,21,21,0.4)' : '#2a2a2a')}`,
                    padding: '10px 12px',
                    fontFamily: "'Bebas Neue','Oswald',sans-serif",
                    fontSize: 12, letterSpacing: '0.12em',
                    cursor: 'pointer', transition: 'all 0.15s',
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2,
                  }}
                >
                  <span style={{ fontSize: 9, opacity: 0.6 }}>{s.short}</span>
                  <span>{s.label}</span>
                </button>
              );
            })}
          </div>

          <CourtsView stage={stage} />

          <div style={{
            marginTop: 14, padding: '12px 14px',
            background: '#111', border: '1px solid #1f1f1f', borderLeft: `3px solid ${RED}`,
            fontSize: 13, color: 'rgba(255,255,255,0.8)', lineHeight: 1.55,
          }}>
            {stage.note}
          </div>

          <div style={{ marginTop: 14, display: 'flex', justifyContent: 'space-between' }}>
            <button
              onClick={() => setStageIdx(i => Math.max(0, i - 1))}
              disabled={stageIdx === 0}
              style={{
                background: 'transparent', border: '1px solid #2a2a2a',
                color: stageIdx === 0 ? '#333' : '#fff',
                padding: '8px 14px',
                fontFamily: "'Bebas Neue','Oswald',sans-serif",
                fontSize: 12, letterSpacing: '0.14em',
                cursor: stageIdx === 0 ? 'not-allowed' : 'pointer',
              }}
            >← BACK</button>
            <button
              onClick={() => setStageIdx(i => Math.min(STAGES.length - 1, i + 1))}
              disabled={stageIdx === STAGES.length - 1}
              style={{
                background: stageIdx === STAGES.length - 1 ? 'transparent' : RED,
                border: 'none',
                color: stageIdx === STAGES.length - 1 ? '#333' : '#fff',
                padding: '8px 14px',
                fontFamily: "'Bebas Neue','Oswald',sans-serif",
                fontSize: 12, letterSpacing: '0.14em',
                cursor: stageIdx === STAGES.length - 1 ? 'not-allowed' : 'pointer',
              }}
            >NEXT →</button>
          </div>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <h2 style={sectionTitle}>PRICING</h2>
          <div style={tableWrap}>
            <table style={tbl} className="blitz-table">
              <tbody>
                <tr><td style={tdLabel}>First 6 players</td><td style={td}>$25 each ($150 base)</td></tr>
                <tr><td style={tdLabel}>Players 7 & 8</td><td style={td}>$12.50 each (half price)</td></tr>
                <tr><td style={tdLabel}>Team of 6</td><td style={td}>$150 total</td></tr>
                <tr><td style={tdLabel}>Team of 7</td><td style={td}>$162.50 total</td></tr>
                <tr><td style={tdLabel}>Team of 8</td><td style={td}>$175 total</td></tr>
                <tr><td style={tdLabel}>Free agent</td><td style={td}>$25 - paid in full upfront, placed on a team by OVR</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <h2 style={sectionTitle}>RULES</h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {[
              ['Round robin', 'Single set, first to 25 (cap 27), 20-min hard stop.'],
              ['Finals', 'Best of 3 sets, 25/25/15, win by 2 capped at 30. No hard stop.'],
              ['Standings', '2 pts per win. Ties broken by head-to-head → point differential → points scored → coin flip.'],
              ['Seeding', '1 vs 2 = Gold Final. 3 vs 4 = Bronze Final. Both run simultaneously.'],
              ['Rotation, libero, subs', 'Standard FIVB + OVR house rules.'],
            ].map(([label, text]) => (
              <li key={label} style={{ padding: '10px 0', borderBottom: '1px solid #1f1f1f', fontSize: 13, color: 'rgba(255,255,255,0.85)', display: 'flex', gap: 12 }}>
                <span style={{ color: RED, fontWeight: 700, flexShrink: 0 }}>·</span>
                <span><strong style={{ color: '#fff' }}>{label}:</strong> {text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div style={sectionWrap} className="blitz-section">
          <h2 style={sectionTitle}>CANCELLATION POLICY</h2>
          <p style={{ fontSize: 14, lineHeight: 1.6, color: 'rgba(255,255,255,0.78)', margin: 0 }}>
            <strong style={{ color: '#fff' }}>Teams</strong> must cancel at least <strong style={{ color: '#fff' }}>5 days</strong> before the tournament start time for a full refund.
            <strong style={{ color: '#fff' }}> Free agents</strong> must cancel at least <strong style={{ color: '#fff' }}>2 days</strong> before the tournament start time for a full refund.
            All refunds are minus payment processing fees.
          </p>
        </div>

        <div className="blitz-close-cta" style={{ padding: '20px 32px 40px', textAlign: 'center' }}>
          <button onClick={onClose} style={{
            background: RED, color: '#fff', border: 'none',
            fontFamily: "'Bebas Neue','Oswald',sans-serif",
            fontSize: 16, letterSpacing: '0.18em',
            padding: '14px 36px', cursor: 'pointer',
          }}>
            GOT IT · TAKE ME BACK
          </button>
        </div>
      </div>
    </div>
  );
}

function CourtsView({ stage }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
      <Court num="1" matchup={stage.court1} />
      <Court num="2" matchup={stage.court2} />
    </div>
  );
}

function Court({ num, matchup }) {
  const isBronze = matchup.tag === 'BRONZE';
  const isGold   = matchup.tag === 'GOLD';
  const accent   = isGold ? GOLD : isBronze ? BRONZE : RED;
  const empty    = matchup.left === '-';
  const solo     = !!matchup.solo;

  return (
    <div style={{
      background: '#0d0d0d',
      border: `1px solid ${empty ? '#1f1f1f' : accent}`,
      padding: 18,
      position: 'relative',
      boxShadow: empty ? 'none' : '0 0 14px rgba(157,21,21,0.15)',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div style={{ fontSize: 10, letterSpacing: '0.2em', color: 'rgba(255,255,255,0.45)', fontFamily: "'Bebas Neue','Oswald',sans-serif" }}>
          COURT {num}
        </div>
        {matchup.tag && (
          <div style={{
            fontSize: 10, letterSpacing: '0.18em',
            color: accent, fontFamily: "'Bebas Neue','Oswald',sans-serif",
            border: `1px solid ${accent}`, padding: '3px 8px',
          }}>
            {matchup.tag}
          </div>
        )}
      </div>

      {solo ? (
        <TeamBadge label={matchup.solo} accent={accent} empty={false} />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <TeamBadge label={matchup.left} accent={accent} empty={empty} />
          <div className="blitz-court-vs" style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 18, color: 'rgba(255,255,255,0.4)', fontWeight: 600,
          }}>
            {empty ? '·' : 'VS'}
          </div>
          <TeamBadge label={matchup.right} accent={accent} empty={empty} />
        </div>
      )}
    </div>
  );
}

function TeamBadge({ label, accent, empty }) {
  return (
    <div style={{
      flex: 1, textAlign: 'center',
      background: empty ? '#111' : 'rgba(157,21,21,0.10)',
      border: `1px solid ${empty ? '#1f1f1f' : 'rgba(157,21,21,0.35)'}`,
      padding: '14px 8px',
    }}>
      <div className="blitz-court-name" style={{
        fontFamily: "'Bebas Neue','Oswald',sans-serif",
        fontSize: 46, letterSpacing: '0.06em',
        color: empty ? 'rgba(255,255,255,0.25)' : '#fff',
        lineHeight: 1,
      }}>
        {label}
      </div>
    </div>
  );
}
